import { gql } from '@apollo/client';

const AccountCreditCardInfoShared = gql`
  fragment AccountCreditCardInfoShared on AccountCreditCard {
    id
    nameOnCard
    maskedNumber
    brand
    defaultCard
    expiryMonth
    expiryYear
    billingAddress
    createdAt
    updatedAt
  }
`;

export default AccountCreditCardInfoShared;
